import React from 'react'
import type { ProviderProps } from './context';
import { Provider } from './context'
import { Layout } from './layout'

export type PasswordlessAuthenticationProps = Omit<ProviderProps, 'children'>

export const PasswordlessAuthentication = (props: PasswordlessAuthenticationProps) => {
  return (
    <Provider url={props.url} recaptchaSiteKey={props.recaptchaSiteKey}>
      <Layout />
    </Provider>
  )
}
